const css = `.reservation-panel .informative-employee-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.reservation-panel .informative-employee-field .clear-informative-employee {
  align-self: flex-start;
  padding: 0;
}
.reservation-panel .group-reservation-clients {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: var(--border-radius);
}
.reservation-panel .group-reservation-clients.invalid-form-field {
  border-color: var(--danger);
}
.reservation-panel .user-display-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.reservation-panel .user-display-container .user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.reservation-panel .user-display-container .pending-user-note {
  font-size: var(--font-size-xs);
  color: var(--text-color-secondary);
  margin-left: 8px;
}
.reservation-panel .user-display-container .user-ongoing-injury-icon {
  color: var(--danger);
  font-weight: var(--font-weight-bold);
}
.reservation-panel .unregistered-client-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.reservation-panel .unregistered-client-container .form-field:not(:last-of-type) {
  margin-bottom: var(--space-6);
}
.reservation-panel .unregistered-client-container .create-user-button {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  width: min-content;
  align-self: center;
}
.reservation-panel .reservation-time-container {
  display: flex;
  gap: 16px;
  width: 100%;
}
.reservation-panel .reservation-coupon-toggle {
  margin-bottom: 0;
}
.reservation-panel .reservation-coupon-toggle.inactive {
  height: 48px;
  margin: unset;
}
.reservation-panel .reservation-coupon-toggle:not(.inactive) {
  margin-top: var(--space-3);
}
.reservation-panel .user-active-coupon-select.adaptive-select-trigger,
.reservation-panel .user-active-coupon-select .p-dropdown-label {
  padding: 0;
  min-height: 48px;
}
.reservation-panel .radio-button-group-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0;
}
.reservation-panel .radio-button-group-container .radio-button-group-title {
  font-weight: var(--font-weight-medium);
}
.reservation-panel .existing-coupon-info {
  margin-top: 4px;
  row-gap: 12px;
}
.reservation-panel .existing-coupon-info .p-tag {
  margin: 0;
}
.reservation-panel .coupon-note {
  position: absolute;
  bottom: -16px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-none);
}
.reservation-panel .coupon-note i {
  font-size: var(--font-size-xs);
}
.reservation-panel .coupon-display + .coupon-note {
  padding-left: 12px;
}
.reservation-panel .p-dropdown + .coupon-note {
  bottom: -20px;
}
.reservation-panel .reservation-hour-container:has(.daily-calendar-container) {
  margin-bottom: 24px;
}
.reservation-panel .user-routine-button {
  padding: 2px;
  height: 30px;
  width: 30px;
  margin-top: unset;
}
.reservation-panel .user-routine-button-error-text {
  color: var(--danger);
}
.reservation-panel .attendance-checkbox,
.reservation-panel .user-attendance {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-color-secondary);
  margin-left: 8px;
  margin-top: -12px;
  margin-left: var(--space-7);
  height: 18px;
}
.reservation-panel .user-attendance i {
  width: 18px;
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-base);
}
.reservation-panel .user-attendance i.pi-user-plus {
  color: var(--success);
}
.reservation-panel .user-attendance i.pi-user-minus {
  color: var(--danger);
}
.reservation-panel .attendance-checkbox .p-checkbox {
  height: 18px;
  width: 18px;
}
.reservation-panel .attendance-checkbox .p-checkbox .p-checkbox-box {
  height: 18px;
  width: 18px;
}
.reservation-panel .attendance-checkbox .p-checkbox .p-checkbox-box svg {
  width: 12px;
  height: 12px;
}
.reservation-panel .reservation-hour-container-touch-hint {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.reservation-panel .daily-calendar-container {
  height: 400px;
}
.reservation-panel .daily-calendar-container.daily-calendar-container-touch {
  height: 100%;
}
.reservation-panel .daily-calendar-container .daily-calendar {
  height: 100%;
  border-radius: var(--border-radius);
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-time-header {
  display: none;
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-time-content {
  border-top: none;
  border-bottom: none;
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-day-slot {
  background-color: var(--surface-sunken);
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-time-view {
  background-color: var(--surface-sunken);
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-time-gutter {
  background-color: var(--surface-raised);
}
.reservation-panel .daily-calendar-container .daily-calendar.invalid-selection .rbc-event.temporary-event {
  background-color: var(--danger);
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-event {
  background-color: var(--primary-color);
  color: var(--accent-text);
  border: none;
  border-radius: var(--border-radius);
  padding: 8px;
  opacity: 0.8;
  cursor: pointer;
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-event.rbc-selected {
  background-color: var(--accent);
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-event.temporary-event {
  background-color: var(--primary-color);
  border: 2px dashed var(--accent);
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-event.temporary-event:hover {
  opacity: 0.8;
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-event.temporary-event .rbc-event-content {
  font-weight: var(--font-weight-semibold);
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-event.blocked-event {
  background-color: var(--text-muted);
  border: none;
  cursor: not-allowed;
  pointer-events: none;
}
.reservation-panel .daily-calendar-container .daily-calendar .rbc-event.blocked-event.rbc-selected {
  background-color: var(--surface-300);
}
.reservation-panel i.pi-arrow-right {
  font-size: var(--font-size-sm);
  margin: 0 4px;
}
.reservation-panel .price-value {
  font-weight: var(--font-weight-semibold);
  color: var(--primary-color);
}
.reservation-panel .price-info {
  padding-left: 8px;
  border-left: 1px solid var(--surface-300);
}
.reservation-panel .button-container {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}
.reservation-panel .queued-users-section {
  margin-top: 16px;
  border: 1px solid var(--surface-200);
  border-radius: var(--border-radius);
  overflow: hidden;
}
.reservation-panel .queued-users-section .queued-users-header {
  padding: 12px;
  background-color: var(--surface-50);
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}
.reservation-panel .queued-users-section .queued-users-header:hover {
  background-color: var(--surface-100);
}
.reservation-panel .queued-users-section .queued-users-header i {
  font-size: var(--font-size-base);
  transition: transform 0.2s;
}
.reservation-panel .queued-users-section .queued-users-header.expanded i {
  transform: rotate(90deg);
}
.reservation-panel .queued-users-section .queued-users-list {
  max-height: 300px;
  overflow-y: auto;
  padding: 12px;
  background-color: var(--surface-0);
}
.reservation-panel .queued-users-section .queued-users-list .text-center {
  text-align: center;
  color: var(--text-color-secondary);
}
.reservation-panel .cancellation-info {
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 4px;
  background-color: var(--danger-subtle);
  border: 1px solid var(--danger);
  width: 100%;
  box-sizing: border-box;
}
.reservation-panel .cancellation-info.warning {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.reservation-panel .cancellation-info.warning .warning-title {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
}
.reservation-panel .cancellation-info.warning .warning-title .warning-icon {
  color: var(--danger);
  font-size: var(--font-size-2xl);
  margin-right: 8px;
}
.reservation-panel .cancellation-info.warning .warning-title span {
  color: var(--danger);
  font-weight: var(--font-weight-semibold);
}
.reservation-panel .cancellation-info .cancellation-details {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--danger);
  width: 100%;
}
.reservation-panel .cancellation-info .cancellation-details p {
  margin: 8px 0;
  color: var(--danger);
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.reservation-panel .cancellation-info .cancellation-details p strong {
  color: var(--danger);
}
.reservation-panel .cancellation-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 8px;
}
.reservation-panel .cancellation-form .form-field {
  width: 100%;
}
.reservation-panel .cancellation-form .form-field .p-dropdown,
.reservation-panel .cancellation-form .form-field .p-inputtextarea {
  width: 100%;
}
.reservation-panel .cancellation-form .form-field:not(:last-child) {
  margin-bottom: 8px;
}
.reservation-panel .panel-header:has(.panel-header-with-button) {
  gap: 8px;
}
.reservation-panel .panel-header-with-button {
  display: flex;
  gap: var(--gap);
  align-items: center;
  width: 100%;
}
.reservation-panel .panel-header-with-button h4 {
  margin: 0;
}

@media screen and (max-width: 768px) {
  .reservation-panel .daily-calendar-container {
    height: 300px;
  }
  .reservation-panel .daily-calendar-container.daily-calendar-container-touch {
    height: 100%;
  }
  .reservation-panel .daily-calendar-container .daily-calendar .rbc-timeslot-group {
    min-height: 40px;
  }
  .reservation-panel .daily-calendar-container .daily-calendar .rbc-event {
    padding: 4px;
    font-size: var(--font-size-sm);
  }
}
.rbc-time-content {
  overscroll-behavior: contain;
}

.p-dialog.cancellation-dialog {
  width: 90vw;
  max-width: 480px;
}
.p-dialog.cancellation-dialog .p-dialog-content {
  padding: var(--space-5) var(--space-1) var(--space-6) !important;
}
.p-dialog.cancellation-dialog .cancellation-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.p-dialog.cancellation-dialog .cancellation-form .form-field {
  width: 100%;
  margin-bottom: 0;
}
.p-dialog.cancellation-dialog .cancellation-form .form-field .p-inputtextarea {
  max-height: 300px;
}
.p-dialog.cancellation-dialog .cancellation-form .form-field .cancellation-info {
  margin-bottom: 0;
}
.p-dialog.cancellation-dialog .cancellation-form .form-field .p-dropdown,
.p-dialog.cancellation-dialog .cancellation-form .form-field .p-inputtextarea {
  width: 100%;
}
.p-dialog.cancellation-dialog .cancellation-info {
  margin-bottom: 24px;
  padding: 16px;
  border-radius: var(--border-radius);
  background-color: var(--info-subtle);
  border: 1px solid var(--info);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
}
.p-dialog.cancellation-dialog .cancellation-info.warning {
  background-color: var(--warning-subtle);
  border-color: var(--warning);
}
.p-dialog.cancellation-dialog .cancellation-info .warning-icon {
  color: var(--warning);
  font-size: var(--font-size-2xl);
  margin-bottom: 4px;
}
.p-dialog.cancellation-dialog .cancellation-info .coupon-info-icon {
  color: var(--info);
  font-size: var(--font-size-2xl);
  margin-right: 8px;
}
.p-dialog.cancellation-dialog .cancellation-info p {
  margin: 0;
  color: var(--warning);
}
.p-dialog.cancellation-dialog .cancellation-info p.warning-title {
  font-weight: var(--font-weight-semibold);
}

.clone-dialog {
  max-width: 600px;
}
.clone-dialog .clone-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.clone-dialog .clone-dialog-content .dialog-message {
  color: var(--text-muted);
}
.clone-dialog .clone-dialog-content .p-inputnumber {
  width: 100%;
}
.clone-dialog .clone-dialog-content .p-inputnumber .p-inputnumber-input {
  max-width: 150px;
}

@media (max-width: 480px) {
  .clone-dialog {
    max-width: 600px;
  }
  .clone-dialog .clone-dialog-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .clone-dialog .clone-dialog-content .form-field {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
